import { topicTags } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题 · 大家都在讨论
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            最新电影在线看、热门电视剧全集、综艺节目在线播放——看看影迷剧迷们都在热议什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicTags.map((tag) => (
            <span
              key={tag.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                colorMap[tag.color] || colorMap.primary
              }`}
            >
              <span className="text-xs opacity-70">#</span>
              {tag.name}
              <span className="text-xs opacity-60 ml-1">{tag.heat}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}